function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.03 7a.652.652 0 00-.451 1.118l3.21 3.23H3.658a.647.647 0 00-.569.322.654.654 0 00.569.98H19.79l-3.211 3.23a.65.65 0 00.285 1.099c.227.06.468-.01.63-.18l4.316-4.34a.652.652 0 000-.92l-4.316-4.341A.64.64 0 0017.03 7z"
});

function SvgNavigationArrowRightinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgNavigationArrowRightinline;